import Vue from 'vue';
import Component from 'vue-class-component';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class HotTicketsSearchComponent extends Vue {
    tableHeaders: Array<any> = [
        { text: 'Вылет', value: 'departure' },
        { text: 'Обратно', value: 'retrieval' },
        { text: 'Куда', value: 'to' },
        { text: 'Авиакомпания', value: 'company' },
        { text: 'Выгода', value: 'profit' },
        { text: 'Цена', value: 'price' },
        { text: '', value: '' }
    ]
    result: Array<any> = [{
        departure: '30 окт',
        retrieval: '2 ноя',
        to: 'Сан Франциско',
        company: 'Aeroflot',
        benefit: 3000,
        price: 18000
    }]

    get hasResult() {
        return this.result && this.result.length;
    }

    get componentClassAttribute() {
        return {
            'hot-tickets-search_has-result': this.hasResult
        };
    }
}
